/* eslint-disable */ 
import {StyleSheet} from 'react-native';


export default StyleSheet.create({
  container: {
    height: '100%',
    // flexGrow: 1,
    paddingTop: 0,
  },
  list: {
    flex: 1,
    flexGrow: 1,
    paddingVertical: 8,
    
  },
  listContent: {margin:20,height:'100%'},
  alertStyle: {marginTop:10},
  newTagStyle:{marginTop:20},
  mainStyle:{marginLeft:20}
});